export const MAX_FEATURES_VISIBLE_VALUE_WITH_LIFT = 4;
export const MAX_FEATURES_VISIBLE_VALUE = 5;
